<template>
    <div
        class="md-form get-more-info-v4"
        :style="{ backgroundColor: bgColor, marginBottom }"
    >
        <module-box
            class="form-container"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <info-agent
                v-if="!noAgent"
                :agent="agent"
                :licenseName="licenseName"
            />
            <div class="info-right">
                <div
                    v-if="title"
                    class="title"
                    v-html="formatFontSize(title, 18)"
                ></div>
                <info-form
                    :registerRole="registerRole"
                    :tag="tag"
                    :questionnaire="questionnaire"
                    :onSubmitOption="onSubmitOption"
                    :formList="formList"
                    :showTitle="false"
                    :lenderStyle="lenderStyle"
                    :defaultMsg="defaultMsg"
                    :submitText="submitOptionText"
                    :submitStyle="{
                        backgroundColor: submitBgColor,
                    }"
                    :registerLogin="registerLogin"
                    @done="handleShowToast"
                    disclaimerColor="#a0a3af"
                />
            </div>
            <form-toast
                v-model:visible="formToastVisible"
                v-bind="formToastOption"
                @confirm="handleToastConfirm"
            />
        </module-box>
    </div>
</template>

<script>
import common from '../index';
import infoAgent from '../info-agent.vue';
import infoForm from '../info-form.vue';
import formToast from '@/components/form-toast';
import { colorBlock } from '../../defaultSpacing';
export default {
    mixins: [common],
    data: function() {
        return {
            ...colorBlock
        };
    },
    computed: {
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
    components: {
        infoAgent,
        infoForm,
        formToast
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.get-more-info-v4 {
    position: relative;
    width: 100%;
    background-color: #f8f9fd;
    @media (min-width: 601px) {
        padding: 40px;
    }
    @media (max-width: 600px) {
        padding: 20px;
    }
    .form-container {
        display: flex;
        position: relative;
        &:not(.mg-container) {
            padding-left: 20px;
            padding-right: 20px;
        }
        .info-agent {
            position: relative;
            flex-shrink: 0;
            margin-right: 40px;
            width: 340px;
            height: 454px;
            &:after {
                position: absolute;
                content: '';
                background: linear-gradient(
                    to top,
                    rgba(33, 33, 33, 0.5),
                    transparent
                );
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            .agent-image {
                width: 100%;
                height: 100%;
            }
            .agent-detail {
                z-index: var(--level-low);
                position: absolute;
                bottom: 20px;
                left: 20px;
                right: 20px;
                color: #fff;
                > p:last-child{
                    margin-bottom: 0;
                }
                .name {
                    font-size: 24px;
                    font-family: var(--font-bold);
                    letter-spacing: -0.5px;
                    line-height: 18px;
                    margin-bottom: 10px;
                }
                .position,
                .phone {
                    font-size: 14px;
                    letter-spacing: -0.4px;
                    line-height: 15px;
                    margin-bottom: 10px;
                }
                .position {
                    span {
                        white-space: nowrap;
                    }
                }
            }
        }
        .info-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            .title {
                flex: none;
                font-size: 18px;
                color: #000000;
                letter-spacing: 0.21px;
                font-family: var(--mg-title-font);
                line-height: 1.11;
                text-align: left;
                padding-bottom: 20px;
                @include webkitBox(2);
                p {
                    line-height: inherit;
                    overflow: hidden;
                }
            }
            .info-form {
                display: flex;
                flex-wrap: wrap;
                height: 100%;
                @include placeholderColor(#c6c8d1);
            }
            .input-content {
                width: 100%;
                display: flex;
                flex-direction: column;
            }
            .basic-info {
                flex: none;
                display: flex;
                flex-wrap: wrap;
                margin-left: -20px;
                margin-top: -20px;
                .input-box {
                    flex-grow: 1;
                    min-width: 230px;
                    margin-left: 20px;
                    margin-top: 20px;
                    position: relative;
                    .mg-error {
                        position: absolute;
                        left: 0;
                        bottom: -18px;
                    }
                    &.question {
                        width: calc(100% - 20px);
                        flex: none;
                    }
                    &.meetTime {
                        .el-input {
                            width: 100%;
                        }
                        .el-input__prefix {
                            left: 15px;
                        }
                        input {
                            text-indent: 25px;
                            color: #000000;
                        }
                    }
                }
                .input-box[class*='paragraphText'] {
                    width: 100%;
                }
                input {
                    display: inline-block;
                    font-size: 14px;
                    height: 45px;
                    background-color: #fff;
                    border: solid 1px var(--color-border);
                    width: 100%;
                    padding-left: 20px;
                }
                textarea {
                    width: 100%;
                    height: 100px;
                    border: solid 1px var(--color-border);
                    padding: 12px 20px;
                    font-size: 14px;
                }
            }
            .submit-content {
                flex: none;
                width: 100%;
                margin-top: 20px;
            }
            .submit {
                display: inline-block;
                height: 45px;
                min-width: 120px;
                max-width: 100%;
                padding: 0 20px;
                text-align: center;
                vertical-align: middle;
                font-size: 14px;
                font-family: var(--mg-button-font);
            }
            .disclaimer-wrap.opt-in{
                align-self: flex-end;
            }
        }
    }
    input[type='button'].toast-btn2 {
        font-family: var(--font-bold);
    }
    @include media-1080 {
        .form-container .info-agent {
            margin-right: 30px;
            .agent-detail {
                left: 11px;
                right: 11px;
            }
        }
    }
    @include media-800 {
        .form-container {
            flex-direction: column;
            .info-agent {
                margin-right: 0;
                margin-bottom: 20px;
                width: 100%;
                height: auto;
                display: flex;
                &::after {
                    display: none;
                }
                .agent-image {
                    width: 80px;
                    height: 80px;
                    margin-right: 17px;
                    flex: none;
                    img {
                        border-radius: 50%;
                    }
                }
                .agent-detail {
                    position: static;
                    flex: 1;
                    .name {
                        font-size: 18px;
                        margin-top: 0;
                        line-height: 20px;
                        color: var(--color-text);
                    }
                    .position {
                        line-height: 150%;
                        margin-top: 4px;
                        color: var(--color-label);
                        span {
                            white-space: normal;
                        }
                    }
                    .phone {
                        line-height: 150%;
                        margin-top: 0;
                        color: var(--color-label);
                    }
                }
            }
        }
    }
    @include media-600 {
        ::-webkit-input-placeholder {
            font-size: 12px;
        }
        ::-moz-placeholder {
            font-size: 12px;
        }
        :-ms-input-placeholder {
            font-size: 12px;
        }
        .form-container {
            overflow: visible;
            &:not(.mg-container) {
                padding-left: 15px;
                padding-right: 15px;
            }
            .info-agent::after {
                display: block;
                background: #fff;
                top: auto;
                bottom: -20px;
                left: -15px;
                right: -15px;
                height: 1px;
            }
            .info-right {
                .title {
                    letter-spacing: normal;
                    font-size: 14px;
                }
                .basic-info {
                    margin-top: -10px;
                    input {
                        height: 40px;
                        line-height: 22px;
                    }
                    textarea {
                        height: 80px;
                    }
                }
                .submit-content {
                    margin-top: 12px;
                }
                .submit {
                    height: 40px;
                    width: 100%;
                }
            }
        }
    }
    .md-agent-contact.standard + &,
    .md-banner.standard + & {
        margin-top: 40px;
    }
}
</style>
